import { CapoPlugin } from "/home/runner/work/tripexpert-frontend/tripexpert-frontend/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];